import React from 'react';
import 'tachyons';
import './Component.css'


const InputBox = (props) =>{
	return(
		<div>
			<input
			onChange={(e) => {props.inputChange(e, props.name)}}
			className='mb2 pa3 ba b--green bg-lightest-blue'
			type='text'
			placeholder={props.placeholder}
			>
			</input>
		</div>
	);
}

export default InputBox;